import styles from './LegacyModalContent.module.scss';

type Props = {
  /**
   * The content to render. Be sure to handle scrolling if your content
   * won't fit on small screens.
   */
  children: React.ReactNode;
  /**
   * The rendered close button provided by `Modal`.
   */
  closeButton?: React.ReactNode;
  /**
   * The maximum width of `ModalContent`. Any valid CSS value can be used.
   * Only strings are supported to avoid special handling for numbers, so
   * make sure to provide a unit such as `px`.
   */
  maxWidth?: string;
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is deprecated in favor of [ModalDialog](https://zinnia-storybook.zapier.com/?path=/docs/display-modaldialog--docs).</span>
 *
 * @deprecated Use `ModalDialog` instead.
 */
export const LegacyModalContentHeader = (props: {
  children: React.ReactNode;
}) => {
  return (
    <header className={styles.modalContentHeader} data-zds>
      {props.children}
    </header>
  );
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is deprecated in favor of [ModalDialog](https://zinnia-storybook.zapier.com/?path=/docs/display-modaldialog--docs).</span>
 *
 * @deprecated Use `ModalDialog` instead.
 */
export const LegacyModalContentBody = (props: {
  size?: 'small' | 'medium';
  children: React.ReactNode;
  scrollable?: boolean;
}) => {
  const { size = props.scrollable ? 'small' : 'medium' } = props;
  return (
    <div
      className={styles.modalContentBody}
      data-scrollable={props.scrollable === true ? '' : undefined}
      data-size={size}
      data-zds
    >
      <div
        className={styles.modalContentBodyInner}
        data-scrollable={props.scrollable === true ? '' : undefined}
        tabIndex={props.scrollable === true ? 0 : undefined}
        data-zds
      >
        {props.children}
      </div>
    </div>
  );
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is deprecated in favor of [ModalDialog](https://zinnia-storybook.zapier.com/?path=/docs/display-modaldialog--docs).</span>
 *
 * @deprecated Use `ModalDialog` instead.
 */
export const LegacyModalContentFooter = (props: {
  children: React.ReactNode;
}) => {
  return (
    <footer className={styles.modalContentFooter}>{props.children}</footer>
  );
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is deprecated in favor of [ModalDialog](https://zinnia-storybook.zapier.com/?path=/docs/display-modaldialog--docs).</span>
 *
 * @deprecated Use `ModalDialog` instead.
 */
export const LegacyModalContent = (props: Props) => {
  const style = {
    maxWidth: props.maxWidth,
  };
  return (
    <div className={styles.root} style={style} data-zds>
      {props.children}
      {props.closeButton && (
        <div className={styles.closeButton}>{props.closeButton}</div>
      )}
    </div>
  );
};
